import { createRoute } from '@tanstack/react-router'
import { mainLayoutRoute } from 'src/layouts/routes'

import { ProfilePage } from '../pages/ProfilePage'

export const profileInfoRoute = createRoute({
  getParentRoute: () => mainLayoutRoute,
  component: () => <ProfilePage />,
  path: '/profile/info'
})
